import LegacyUpsell from 'components/LegacyUpsell';

export default function Upsell() {
  /*
    This component previously rendered different upsell components depending on experiment results.
    I think it's worth keeping this since we'll likely run this experiment again with a different upsell.    
  */
  return <LegacyUpsell />;
}
